module.exports = __webpack_public_path__ + "img/saddle-cloths-16.eff3126a.svg";